import { getSettingsProfileApi as generatedGetSettingsProfileApi } from '../generated/settingsProfile/getSettingsProfile';

const getSettingsProfileApi = generatedGetSettingsProfileApi.enhanceEndpoints({
  endpoints: {
    getSettingsProfile: {
      providesTags: ['SettingsProfile'],
    },
  },
});

export const { useGetSettingsProfileQuery } = getSettingsProfileApi;
export { getSettingsProfileApi };
